var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddProposalCard from '../../Components/AddProposalCard/AddProposalCard';
import DashboardBottomSheet from '../../Components/Dashboard/DashboardBottomSheet';
import { checkIfCookieExists, deleteCookie, removeEntryFromArray } from '../../Util/data';
import { deleteProposal, proposalShareRegister } from '../../Util/ApiService';
import MyPitchesCard from '../../Components/MyPitchesCard/MyPitchesCard';
import displayToast from '../../Util/Toast';
import ProposalShareModal from '../../Components/Modal/ProposalShareModal';
import GeneralModal from '../../Components/Modal/GeneralModal';
const MyPitchesPage = ({ createProposalUri, deleteProposalUri, nudgeCount, packageChooseUrl, pitchAndDealUrl, pitchEditUrl, proposalExtrasUrl, proposalShareUrl, publishProposalUrl, purchaseNudgesUrl, preFetchedProposals = null, subscriptionTypes = null, takeOfflineUrl }) => {
    const { t } = useTranslation();
    const preSetProposals = preFetchedProposals
        ? JSON.parse(preFetchedProposals)
        : null;
    const [proposals, setProposals] = useState([]);
    const [displayOverlay, setDisplayOverlay] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalDescription, setModalDescription] = useState('');
    const [modalType, setModalType] = useState(null);
    const [confirmButtonText, setConfirmButtonText] = useState('');
    const [discardButtonText, setDiscardButtonText] = useState('');
    const [selectedProposalIdForDeletion] = useState(null);
    const [shareUrls, setShareUrls] = useState([]);
    const [loadingShareUrls, setLoadingShareUrls] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedProposalShareUrl, setSelectedProposalShareUrl] = useState(null);
    const [displayShareModal, setDisplayShareModal] = useState(false);
    const [displayGeneralModal, setDisplayGeneralModal] = useState(false);
    const [hasModalIcon, setHasModalIcon] = useState(false);
    const [modalIconUrl, setModalIconUrl] = useState(null);
    const [modalHasButtons, setModalHasButtons] = useState(false);
    const [modalPrimaryButtonText] = useState(t('proposalDashboard.incompleteFieldsModal.continue'));
    const [modalSecondaryButtonText] = useState(t('proposalDashboard.incompleteFieldsModal.addMoreInfo'));
    const [secondaryButtonLink, setSecondaryButtonLink] = useState('');
    const [selectedProposalId, setSelectedProposalId] = useState(null);
    const [selectedProposalToPublish, setSelectedProposalToPublish] = useState(null);
    // Cookie name for proposal publish or sent for approval
    const proposalPublishOrSentForApprovalCookie = 'proposalPublishOrSentForApprovalCookie';
    const handleConfirmClick = (type) => __awaiter(void 0, void 0, void 0, function* () {
        if (type === 'add') {
            // eslint-disable-next-line no-undef
            window.location.href = createProposalUri;
        }
        else if (type === 'delete') {
            if (!selectedProposalIdForDeletion) {
                return;
            }
            yield deleteProposal(deleteProposalUri.replace('PROPOSAL_ID', selectedProposalIdForDeletion.toString())).then(() => {
                const selectedProposal = proposals.find((proposal) => {
                    return proposal.proposalId === selectedProposalIdForDeletion;
                });
                const selectedProposalIndex = proposals.indexOf(selectedProposal);
                const proposalsArray = [...proposals];
                const newArray = removeEntryFromArray(proposalsArray, selectedProposalIndex);
                setProposals([...newArray]);
                setDisplayOverlay(false);
            });
        }
    });
    const handleCreatePitchClick = () => {
        if (proposals.length) {
            setDisplayOverlay(true);
            setModalType('add');
            setModalTitle(t('entrepreneurDashboard.modals.alreadyHavePitch.title'));
            setModalDescription(t('entrepreneurDashboard.modals.alreadyHavePitch.description'));
            setConfirmButtonText(t('entrepreneurDashboard.modals.alreadyHavePitch.button1'));
            setDiscardButtonText(t('entrepreneurDashboard.modals.alreadyHavePitch.button2'));
        }
        else {
            // eslint-disable-next-line no-undef
            window.location.href = createProposalUri;
        }
    };
    const mapProposalShareUrls = () => {
        if (preSetProposals === null || preSetProposals === void 0 ? void 0 : preSetProposals.length) {
            preSetProposals.forEach((proposal) => __awaiter(void 0, void 0, void 0, function* () {
                const shareUrl = proposalShareUrl.replace('_PROPOSAL_ID_', proposal.proposalId.toString());
                try {
                    const response = yield proposalShareRegister(shareUrl);
                    if (response) {
                        setShareUrls((prevShareUrls) => [
                            ...prevShareUrls,
                            { proposalId: proposal.proposalId, shareUrl: response.url }
                        ]);
                    }
                }
                catch (error) {
                    displayToast(t('toast.error'), 'error');
                }
            }));
        }
    };
    const openShareModal = (proposalId) => {
        const selectedProposal = shareUrls.find((shareUrl) => {
            return shareUrl.proposalId === proposalId;
        });
        setSelectedProposalShareUrl((selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.shareUrl) || null);
        setDisplayShareModal(true);
    };
    const takeProposalLive = (proposalId) => {
        setLoading(true);
        setSelectedProposalToPublish(proposalId);
        setTimeout(() => {
            setSelectedProposalToPublish(null);
            setLoading(false);
        }, 6000);
    };
    const toggleModalDisplay = (proposalId, title, description, hasIcon, iconUrl) => {
        setSelectedProposalId(proposalId);
        if (title === t('proposalDashboard.incompleteFieldsModal.title')) {
            setModalHasButtons(true);
            setSecondaryButtonLink(pitchAndDealUrl.replace('_PROPOSAL_ID_', proposalId.toString()));
        }
        setModalTitle(title);
        setModalDescription(description || '');
        setDisplayGeneralModal(true);
        if (hasIcon && iconUrl) {
            setHasModalIcon(true);
            setModalIconUrl(iconUrl);
        }
    };
    useEffect(() => {
        if (preSetProposals) {
            shareUrls.length !== preSetProposals.length
                ? setLoadingShareUrls(true)
                : setLoadingShareUrls(false);
        }
    }, [shareUrls]);
    useEffect(() => {
        if (preSetProposals) {
            mapProposalShareUrls();
            return setProposals(preSetProposals);
        }
        if (checkIfCookieExists(proposalPublishOrSentForApprovalCookie)) {
            setModalTitle(t('proposalDashboard.successMessage').replace(/%break%/g, '<br/>'));
            setHasModalIcon(true);
            setModalIconUrl('/images/small/icons/icon-cir-check.png');
            setDisplayGeneralModal(true);
            deleteCookie(proposalPublishOrSentForApprovalCookie);
        }
    }, []);
    return (React.createElement("div", { className: "w-full bg-gray-50 py-8" },
        React.createElement("div", { className: "w-full flex flex-col gap-8 max-w-[800px] lg:px-0 px-4 mx-auto" },
            React.createElement(AddProposalCard, { buttonTitle: t('myPitches.createNewPitch'), onClick: handleCreatePitchClick, type: "horizontal" }), proposals === null || proposals === void 0 ? void 0 :
            proposals.map((proposal) => {
                return (React.createElement(MyPitchesCard, { key: proposal.proposalId, displayModal: toggleModalDisplay, hideModal: () => {
                        return setDisplayGeneralModal(false);
                    }, loadingShareUrls: loadingShareUrls, nudgeCount: nudgeCount, packageChooseUrl: packageChooseUrl, pitchEditUrl: pitchEditUrl, proposalExtrasUrl: proposalExtrasUrl, purchaseNudgesUrl: purchaseNudgesUrl, proposal: proposal, publishProposalUrl: publishProposalUrl, selectedProposalToPublish: selectedProposalToPublish, subscriptionTypeCodes: subscriptionTypes, takeOfflineUrl: takeOfflineUrl, toggleShareModal: openShareModal }));
            })),
        displayOverlay && (React.createElement(DashboardBottomSheet, { title: modalTitle, description: modalDescription, confirmButtonText: confirmButtonText, discardButtonText: discardButtonText, handleConfirmButtonClick: (type) => {
                return handleConfirmClick(type);
            }, hideModal: () => {
                return setDisplayOverlay(false);
            }, modalType: modalType })),
        displayShareModal && (React.createElement(ProposalShareModal, { hideProposalShareModal: () => {
                return setDisplayShareModal(false);
            }, shareLink: selectedProposalShareUrl })),
        displayGeneralModal && (React.createElement(GeneralModal, { title: modalTitle, description: modalDescription.length ? modalDescription : null, displayIcon: hasModalIcon, loading: loading, hasButtons: modalHasButtons, yesButtonText: modalPrimaryButtonText, yesButtonFunction: () => {
                return takeProposalLive(selectedProposalId);
            }, noButtonText: modalSecondaryButtonText, noButtonUrl: secondaryButtonLink, iconUrl: modalIconUrl || undefined, closeModal: () => {
                return setDisplayGeneralModal(false);
            } }))));
};
export default MyPitchesPage;
